import { Chip } from '@mui/material';
import { EStatusLinkManagement } from '@organisms/Tables/Enterprise/LinksManagementTable/enums';
import { getConfigStatusLinkManagement } from '@organisms/Tables/Enterprise/LinksManagementTable/utils';
import React, { useMemo } from 'react';

interface ILinkManagementStatusProps {
  status: EStatusLinkManagement;
}

const LinkManagementStatus = ({ status }: ILinkManagementStatusProps) => {
  const statusConfig = useMemo(() => {
    return getConfigStatusLinkManagement(status);
  }, [status]);

  return (
    <Chip
      sx={{
        width: '100%',
        maxWidth: '150px',
        color: statusConfig?.color,
        backgroundColor: statusConfig?.backgroundColor,
      }}
      label={statusConfig?.status}
      variant="filled"
    />
  );
};

export default React.memo(LinkManagementStatus);
